export default {
    isForbidden: false,
    detectFailCount: 0,
    maxFailCount: 2,
    initialDevicePixelRatio: window.devicePixelRatio,
    initialInnerWidth: window.innerWidth,
    initialInnerHeight: window.innerHeight,

    init(Vue) {
        this.disableContextMenu();
        this.listenHotkeys();
        this.immediateDetect(Vue);
        this.detectDevTools(Vue);
    },

    disableContextMenu() {
        window.addEventListener('contextmenu', (e) => e.preventDefault());
    },

    listenHotkeys() {
        window.addEventListener('keydown', (e) => {
            const forbiddenKeys = [
                e.keyCode === 123,
                e.ctrlKey && e.shiftKey && e.keyCode === 73,
                e.ctrlKey && e.shiftKey && e.keyCode === 74,
                e.ctrlKey && e.keyCode === 85
            ];
            if (forbiddenKeys.some(Boolean)) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        });
    },

    immediateDetect(Vue) {
        const initDetect = () => {
            if (this.isForbidden) return;

            const sizeCheck = this.checkWindowSize();
            const debuggerCheck = this.checkDebuggerOpen();

            if (sizeCheck || debuggerCheck) {
                this.detectFailCount++;
            } else {
                this.detectFailCount = 0;
            }
        };

        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            initDetect();
        } else {
            document.addEventListener('DOMContentLoaded', initDetect);
        }

        Vue.mixin({
            mounted() {
                if (this.$root === this && !this.isForbidden) {
                    setTimeout(initDetect, 500);
                }
            }
        });
    },

    checkZoomLevel() {
        // 检查是否是合理的缩放比例变化
        if (this.initialInnerWidth === 0 || this.initialInnerHeight === 0) return false;

        const widthRatio = window.innerWidth / this.initialInnerWidth;
        const heightRatio = window.innerHeight / this.initialInnerHeight;

        // 允许 0.1x 到 5x 的缩放范围（涵盖了大部分正常的缩放情况）
        const minZoom = 0.1;
        const maxZoom = 5.0;

        // 如果宽高比变化一致且在合理范围内，认为这是缩放
        const ratioDiff = Math.abs(widthRatio - heightRatio);
        const isReasonableZoom = widthRatio >= minZoom && widthRatio <= maxZoom &&
                                heightRatio >= minZoom && heightRatio <= maxZoom &&
                                ratioDiff < 0.5; // 宽高比变化不超过50%

        return isReasonableZoom;
    },

    checkWindowSize() {
        if (this.isForbidden || window.innerWidth === 0 || window.innerHeight === 0) return false;

        // 如果检测到浏览器缩放，跳过窗口尺寸检查
        if (this.checkZoomLevel()) return false;

        const widthThreshold = 300;
        const widthDiff = window.outerWidth - window.innerWidth;
        const heightThreshold = 200;
        const heightDiff = window.outerHeight - window.innerHeight;

        return (widthDiff > widthThreshold && widthDiff < screen.width * 0.7) ||
            (heightDiff > heightThreshold && heightDiff < screen.height * 0.7);
    },

    checkDebuggerOpen() {
        if (this.isForbidden) return false;

        let isOpen = false;
        const start = performance.now();
        try {
            debugger;
            const end = performance.now();
            isOpen = end - start > 20;
        } catch (e) {
            isOpen = false;
        }

        if (!isOpen) {
            try {
                const temp = {};
                Object.defineProperty(temp, 'devtools', {
                    get: () => {
                        isOpen = true;
                        return false;
                    },
                    configurable: true
                });
                console.log(temp);
                console.clear();
            } catch (e) {
                isOpen = false;
            }
        }

        return isOpen;
    },

    detectDevTools(Vue) {
        const debounce = (fn, delay) => {
            let timer = null;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => fn.apply(this, args), delay);
            };
        };

        const comprehensiveDetect = debounce(() => {
            if (this.isForbidden) return;

            const sizeCheck = this.checkWindowSize();
            const debuggerCheck = this.checkDebuggerOpen();

            if (sizeCheck || debuggerCheck) {
                this.detectFailCount++;
                if (this.detectFailCount >= this.maxFailCount) {
                    this.handleDevToolsOpen(Vue);
                    this.isForbidden = true;
                }
            } else {
                this.detectFailCount = 0;
            }
        }, 1000);

        setInterval(comprehensiveDetect, 2000);
        window.addEventListener('resize', comprehensiveDetect);
        document.addEventListener('visibilitychange', comprehensiveDetect);
    },

    handleDevToolsOpen(Vue) {
        const appContainer = document.getElementById('app');
        if (appContainer) {
            appContainer.innerHTML = `
              <div style="text-align:center; padding: 50px; font-family: Arial;">
                <h2 style="color: #e53e3e;">检测到非法调试行为</h2>
                <p style="margin-top: 20px; font-size: 16px;">为保障系统安全，页面已暂时禁用</p>
                <p style="margin-top: 10px; color: #666;">刷新页面可恢复（请勿再次打开开发者工具）</p>
              </div>
            `;
        }

        const rootVm = Vue.prototype.$root;
        if (rootVm && !rootVm._isDestroyed) {
            rootVm.$destroy();
        }
    }
};
